<dt class="mt-3"
    [innerHTML]="field.label | translate"></dt>
<dd>
  <ng-container *ngIf="field.template; else REGULAR">
    {{ parse(field, source) }}
  </ng-container>
  <ng-template #REGULAR>
    {{ source[field.key] }}
  </ng-template>
</dd>
